import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function AllGiven({ onLearnMoreClick }) {
    return (
        <span className="statusbar__missing-status">
            <Translation
                translationKey="catalog-missing-status-speed-load-index-hint"
            />
            {' '}
            <Translation
                className="statusbar__learn-more-link"
                translationKey="catalog-missing-status-speed-load-index-learn-more"
                onClick={onLearnMoreClick}
            />
        </span>
    );
}

AllGiven.propTypes = {
    onLearnMoreClick: PropTypes.func.isRequired
};

export default AllGiven;
